export const InjuredPersonType = {
    Visitor: 'Visitor',
    Temp: 'Temp',
    Permanent: 'Permanent',
} as const

export type InjuredPersonType = (typeof InjuredPersonType)[keyof typeof InjuredPersonType]

export const NatureOfInjuryOptions = [
    'Abrasion (Scratch)',
    'Amputation',
    'Bruise/Contusion',
    'Burn - Chemical',
    'Burn - Heat',
    'Chemical Exposure',
    'Cold Stress',
    'Concussion',
    'Crushing Injury',
    'Cumulative Trauma',
    'Dislocation',
    'Foreign Body in the Eye',
    'Fracture',
    'Hearing Loss',
    'Heat Stress/ Heat Stroke',
    'Hernia',
    'Infection',
    'Insect Sting / Animal Bite',
    'Irritation',
    'Sprain/Strain',
    'Puncture',
    'Respiratory',
    'Skin Disorder',
    'Laceration',
    'Other?',
] as const

export const MechanismOfInjuryOptions = [
    'Slip, Trip, Fall',
    'Struck By',
    'Caught Between',
    'Electrocution',
    'Vibration',
    'Trench and Excavation Collapse',
    'Walking and Working Surfaces',
    'Ergonomics',
    'Pressure to complete task',
    'Pinch Point',
    'Open Hole',
    'Equipment/Tool Modification?',
    'Other',
    'Suspended Load',
] as const

export const BodyPartInjuredOptions = [
    'Head',
    'Eye',
    'Ear',
    'Nose',
    'Mouth',
    'Jaw',
    'Teeth',
    'Neck',
    'Shoulder',
    'Chest/Ribs',
    'Back - Upper, Lower',
    'Spine - Cervical, Thoracic, Lumbar, Sacrum, Coccyx',
    'Upper Arm',
    'Elbow',
    'Forearm',
    'Wrist/ Hand',
    'Finger',
    'Abdomen',
    'Pelvis',
    'Hip',
    'Groin',
    'Thigh',
    'Knee',
    'Lower Leg',
    'Foot',
    'Ankle',
    'Toe',
    'Other?',
] as const

export class EmployeeInjuryReportWitness {
    id = ''
    injuryReportId = ''
    sortOrder = 0
    name = ''
    phone = ''
    statement = ''
}

export class EmployeeInjuryReport {
    id!: string
    indexId!: number
    injuryDateTime?: Date | string | null
    job?: string | null
    injuredEmployeeHrRef?: number | null
    location?: string | null
    onCompanyProperty = false
    onJobSite = false
    onHighway = false
    onFreeway = false
    policeNotified = false
    policeReportNumber?: string | null
    fireEmsNotified = false
    injuredEmployeeFullSignature?: string | null
    erWorkMedTreatment = false
    firstReportOfInjuryOnly = false
    death = false
    employeeDateOfBirth?: Date | string | null
    hireDate?: Date | string | null
    department?: string | null
    jobTitle?: string | null
    siteSuperintendent?: string | null
    employeeSuperintendent?: string | null
    foreman?: string | null
    reportedToSafetyDateTime?: Date | string | null
    injuredPersonType?: InjuredPersonType | string | null
    dailyMeetingCompleted = false
    injuryDescription?: string | null
    postInjuryDrugTest = false
    unsafeWorkingConditions = false
    injuredEmployeeSignature?: string | null
    injuredEmployeeSignedOn?: Date | string | null
    witnessToInjury = false
    natureOfInjury?: string | null
    natureOfInjuryOther?: string | null
    mechanismOfInjury?: string | null
    mechanismOfInjuryOther?: string | null
    bodyPartsInjured?: string | null
    bodyPartsInjuredOther?: string | null
    fullDutyNoRestrictions = false
    modifiedLightDutyRequired = false
    modifiedDutyDocumentSigned = false
    rootCause?: string | null
    correctiveAction?: string | null
    primaryCause?: string | null
    documentCompleteSignature?: string | null
    documentCompleteSignedOn?: Date | string | null
    createdOn?: Date | string | null
    createdByUserId?: string | null
    archived!: boolean

    witnesses: EmployeeInjuryReportWitness[] = []
    imageUrls: string[] = []
    imageFileNames: string[] = []

    jobDisplay?: string | null
    workStatusDisplay?: string | null

    static createNew(): EmployeeInjuryReport {
        const item = new EmployeeInjuryReport()
        item.id = crypto.randomUUID()
        return item
    }

    protected $setProperties(source: any): void {
        source.witnesses = source.witnesses ?? []
        source.imageUrls = source.imageUrls ?? []
        source.imageFileNames = source.imageFileNames ?? []
        source.jobDisplay = source.jobDisplay ?? source.job ?? ''
    }
}
